// 🚀 현재 로그인한 사람의 권한을 한 곳에 보관한다.
// 화면마다 user 를 넘겨받지 않아도 '읽기 전용 계정인지'를 알 수 있게 하기 위함이다.
// ※ 진짜 차단은 Firestore 보안 규칙이 한다. 여기는 버튼을 감추고,
//    실수로 저장이 시도되는 것을 미리 막는 이중 안전장치다.

export const VIEWER_ROLE = 'VIEWER';
export const VIEWER_MSG = '읽기 전용(모니터링) 계정입니다. 입력·수정·삭제 권한이 없습니다.';

let currentRole = '';

/** 로그인/세션 복원 시 App 이 호출한다(로그아웃 시엔 빈 값). */
export const setCurrentRole = (role) => { currentRole = role || ''; };
export const getCurrentRole = () => currentRole;

/** 외부 공개용 모니터링 전용 계정인가 */
export const isViewer = () => currentRole === VIEWER_ROLE;

/** 화면에 입력·수정·삭제 버튼을 보여도 되는가 */
export const canEdit = () => currentRole !== VIEWER_ROLE;

/** 쓰기 직전에 호출한다. 읽기 전용 계정이면 여기서 막는다. */
export const assertCanEdit = () => {
  if (isViewer()) throw new Error(VIEWER_MSG);
};

/**
 * 고객 이름 가리기.
 * 외부 공개용 읽기 전용 계정에게는 개인 식별을 막기 위해 첫 글자만 남긴다.
 * (예: 홍길동 -> 홍**, 셔틀버스연대조합 -> 셔****)
 * 일반 직원·관리자에게는 원래 이름을 그대로 돌려준다.
 */
export const maskIfViewer = (name) => {
  if (!isViewer()) return name;
  const s = String(name || '').trim();
  if (!s) return '-';
  if (s.length === 1) return '*';
  return s[0] + '*'.repeat(Math.min(s.length - 1, 4));
};

/** 마스터(관리자) 계정인가 — 되돌리기 어려운 일괄 작업 버튼 노출에 쓴다. */
export const isAdminUser = () => currentRole === 'ADMIN';
